<template>
  <div class="l-breadcrumb">
    <div class="l-breadcrumb__inner">
      <ol
        class="breadcrumb"
        itemscope
        itemtype="https://schema.org/BreadcrumbList"
      >
        <li
          itemprop="itemListElement"
          itemscope
          itemtype="https://schema.org/ListItem"
          v-for="(breadcrumb, index) in breadcrumbs.data"
          :key="breadcrumb.name"
        >
          <a itemprop="item" v-if="breadcrumb.path" :href="breadcrumb.path">
            <span itemprop="name">{{ breadcrumb.name }}</span>
          </a>
          <span itemprop="name" v-else class="l-breadcrumb__text">
            <span itemprop="name">{{ breadcrumb.name }}</span>
          </span>
          <meta itemprop="position" :content="index" />
        </li>
      </ol>
    </div>
  </div>
</template>

<style>
.l-breadcrumb {
  margin: 0 auto;
  width: 1000px;
}

.breadcrumb {
  margin-top: 5px;
  margin-bottom: 5px;
  padding: 0;
  list-style: none;
  font-size: 14px;
}

.breadcrumb li {
  display: inline;
  list-style: none;
  font-weight: bold;
}

.breadcrumb li:after {
  content: '>';
  padding: 0 0.2em;
  color: #555;
}

.breadcrumb li:last-child:after {
  content: '';
}

.breadcrumb li a {
  text-decoration: none;
  color: rgb(9, 81, 141);
}

.breadcrumb li a:hover {
  text-decoration: underline;
}

@media screen and (max-width: 480px) {
  .l-breadcrumb {
    margin: 0 auto;
    width: 100%;
  }
  .breadcrumb {
    margin: 5px;
    padding: 0;
    list-style: none;
    font-size: 14px;
  }
}
</style>

<script>
export default {
  props: {
    breadcrumbs: Object,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/modules/Breadcrumb.vue